import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'reactstrap';
import InscriptionForm from './InscriptionForm';
import Confirm from '../../../shared/components/Confirm';
import {
  fetchStudent,
  fetchSelectStudentValues,
} from '../../../redux/actions/studentsActions';
import {
  fetchAllSubjectsBySemesters,
  saveStudentSubjects,
} from '../../../redux/actions/studentSubjectsActions';
import {
  createErrorMessage,
  createSuccessMessage,
  createWarningMessage,
} from '../../../helpers/notification';
import LoadingSpinner from '../../../shared/components/LoadingSpinner';
import { SidebarProps } from '../../../shared/prop-types/ReducerProps';
import simplifyCurriculumName from '../../../helpers/stringFormat';

class InscriptionContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      materiasModificadas: [],
    };
  }

  componentDidMount() {
    this.fetchStudentList();
  }

  fetchStudentData = (perfilAlumnoId) => {
    if (!perfilAlumnoId) {
      this.setState({ loaded: true });
      return;
    }

    const { history } = this.props;
    fetchStudent(perfilAlumnoId, {
      onSuccess: (dto) => {
        const {
          id,
          numeroLegajo,
          nombre,
          apellido,
          malla,
          hasManifiestoConformidad,
        } = dto;
        const student = {
          perfilAlumnoId,
          value: id,
          hasManifiestoConformidad,
          label: `${numeroLegajo}: ${nombre} ${apellido}, ${simplifyCurriculumName(malla)}`,
        };
        this.setState({ student, loaded: true });
      },
      onError: (error) => {
        if (error && error.status === 404) {
          createErrorMessage('El alumno no existe');
          history.push('/pages/student-subjects');
        } else {
          createErrorMessage('Error al intentar cargar los datos del alumno');
        }
      },
    });
  }

  fetchStudentList = () => {
    fetchSelectStudentValues({
      onSuccess: (students = []) => {
        this.setState({ students, loaded: true });

        if (students.length === 1) {
          const student = students[0];
          this.onChangeStudent(student.value);
        }
      },
      onError: () => {
        createErrorMessage('Error al intentar cargar los datos de alumnos');
      },
    });
  }

  fetchSubjectList = (perfilAlumnoId) => {
    fetchAllSubjectsBySemesters({
      perfilAlumnoId,
      onSuccess: (subjects) => {
        this.setState({ subjects });
      },
      onError: () => {
        createErrorMessage('Error al intentar cargar las materias');
      },
    });
  }

  onInscriptionChanges = (id, evt) => {
    if (evt.target) {
      const { materiasModificadas } = this.state;
      const subject = materiasModificadas.find(i => i.materiaPeriodoId === id);
      if (!subject) {
        materiasModificadas.push({
          materiaPeriodoId: id,
          inscripto: evt.target.checked,
        });
        this.setState({ materiasModificadas });
      } else {
        subject.inscripto = evt.target.checked;
        this.setState({ materiasModificadas });
      }
    }
  }

  handleSave = (values = {}) => {
    const { student: { value: perfilAlumnoId }, conforme } = values;
    const { materiasModificadas } = this.state;
    const params = { materiasModificadas, perfilAlumnoId, conforme };
    const { history } = this.props;

    this.setState({ loaded: false });

    saveStudentSubjects(params, {
      onSuccess: ({ message = [] }) => {
        this.setState({ loaded: true });

        if (message.length) {
          const success = message.filter(m => m.success)
            .map((m, index) => <li key={`${m.success}`} value={index + 1}>{m.success}</li>);

          const error = message.filter(m => m.error)
            .map((m, index) => <li key={`${m.error}`} value={index + 1}>{m.error}</li>);

          if (success.length) {
            createSuccessMessage(<ol>{success}</ol>);
          }

          if (error.length === 0) {
            history.push('/pages/student-subjects');
            return;
          }

          createWarningMessage(<ol>{error}</ol>);

          this.fetchStudentData(perfilAlumnoId);
          this.fetchSubjectList(perfilAlumnoId);

          return;
        }

        createSuccessMessage('Inscripción guardada exitosamente');
        history.push('/pages/student-subjects');
      },
      onError: (error) => {
        if (error.message) {
          createWarningMessage(error.message, 4000);
        } else {
          createErrorMessage('Ocurrió un error al intentar guardar la inscripción');
        }

        this.setState({ loaded: true });
      },
    });
  };

  handleSubmit = (values) => {
    const { student = null } = values;

    if (!student || !student.value) {
      createWarningMessage(<ol>Debe seleccionar al alumno</ol>);

      return;
    }

    if (student.hasManifiestoConformidad) {
      this.handleSave({
        ...values,
        conforme: false,
      });
      return;
    }


    Confirm({
      title: 'Manifiesto de Conformidad',
      question: `
        ¿Declaro bajo fe de juramento interiorizarme de todos los Reglamentos institucionales
        y me comprometo a respetarlos y a acatar las sanciones disciplinarias respectivas, si así no lo hiciere?
        `,
      yesLabel: 'Sí, Acepto',
      noLabel: 'No, Volver',
      onConfirm: () => {
        this.handleSave({
          ...values,
          conforme: true,
        });
      },
    });
  }

  onChangeStudent = (id) => {
    if (!id) {
      this.setState({ subjects: [], materiasModificadas: [], student: null });
      return;
    }

    this.fetchStudentData(id);
    this.fetchSubjectList(id);
  }

  handleOnBack = () => {
    const { history } = this.props;
    history.goBack();
  }

  render() {
    const { id, history } = this.props;
    const { sidebar: { viewPageAs } } = this.props;
    const {
      student = null,
      loaded,
      students = [],
      subjects = [],
      materiasModificadas = [],
    } = this.state;

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">
              Inscripci&oacute;n a materias
            </h3>
            <h3 className="page-subhead subhead">
              {id ? 'Modifica ' : 'Ingresa '}
              la informaci&oacute;n de materias del alumno
            </h3>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {!(loaded && students.length)
              ? <LoadingSpinner />
              : (
                <InscriptionForm
                  {...student}
                  student={student}
                  onSubmit={this.handleSubmit}
                  onChangeStudent={this.onChangeStudent}
                  onBack={this.handleOnBack}
                  initialValues={student}
                  history={history}
                  students={students}
                  subjects={subjects}
                  viewPageAs={viewPageAs}
                  materiasModificadas={materiasModificadas}
                  onInscriptionChanges={this.onInscriptionChanges}
                />
              )
            }
          </Col>
        </Row>
      </Container>
    );
  }
}

InscriptionContainer.propTypes = {
  id: PropTypes.string.isRequired,
  history: PropTypes.shape({}).isRequired,
  sidebar: SidebarProps.isRequired,
};

export default withRouter(connect(state => ({
  sidebar: state.sidebar,
}))(InscriptionContainer));
